import React, { useContext } from 'react';
// import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import NavbarWrapper from '../../../components/Navbar';
import Button from '../../../components/Button';
import Logo from '../../../components/UIElements/Logo';
import Box from '../../../components/Box';
import HamburgMenu from '../../../components/HamburgMenu';
import Container from '../../../components/UI/Container';
import { DrawerContext } from '../../../contexts/DrawerContext';
import ScrollSpyMenu from '../../../components/ScrollSpyMenu';
// import { Link } from 'gatsby';
import { enFr, getLang } from '../../../utils';
import { fixImagePaths } from '../../../utils/image-helpers';

import awakenData from '../../../assets/data/awaken/index.json';
import awakenFrenchData from '../../../assets/data/awaken-french/index.json';

const Navbar = ({ navbarStyle, logoStyle, button, row, menuWrapper }) => {
  // const Data = useStaticQuery(graphql`
  //   query {
  //     awakenJson {
  //       MENU_ITEMS {
  //         label
  //         path
  //         offset
  //       }
  //     }
  //     awakenFrenchJson {
  //       MENU_ITEMS {
  //         label
  //         path
  //         offset
  //       }
  //     }
  //   }
  // `);

  const lang = getLang();
  const localizedData = fixImagePaths(lang === 'fr' ? awakenFrenchData : awakenData);

  const { state, dispatch } = useContext(DrawerContext);

  // Toggle drawer
  const toggleHandler = () => {
    dispatch({
      type: 'TOGGLE'
    });
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const NAV_OFFSET = 70;
      const y = contactSection.getBoundingClientRect().top + window.pageYOffset - NAV_OFFSET;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <NavbarWrapper {...navbarStyle} className="saas_navbar">
      <Container>
        <Box {...row}>
          <Logo
            href="#welcome"
            useWhiteLogo={true}
            // logoSrc={LogoImage}
            title="Awaken Solutions"
            logoStyle={logoStyle}
            className={`main-logo ${lang === 'fr' && 'french'}`}
          />
          <Logo
            href="#welcome"
            useWhiteLogo={false}
            // logoSrc={LogoImageAlt}
            title="Awaken Solutions"
            logoStyle={logoStyle}
            className={`logo-alt ${lang === 'fr' && 'french'}`}
          />
          <Box {...menuWrapper}>
            <ScrollSpyMenu
              className="main_menu"
              menuItems={localizedData.MENU_ITEMS}
              offset={-70}
            />
            <a
              href={`${enFr(
                'https://www.solutionsawaken.com',
                'https://www.awakensolutions.com'
              )}${typeof window !== 'undefined' ? window.location.pathname + window.location.search + window.location.hash : '/'}`}
              className="navbar_button_plain_text"
              style={{ display: 'inline-block', marginRight: '12px' }}
            >
              {enFr('Français', 'English')}
            </a>
            <Button
              {...button}
              title={enFr('GET IN TOUCH', 'NOUS CONTACTER')}
              onClick={scrollToContact}
              className={`contact_button ${state.isOpen ? 'hide_on_drawer_open' : ''}`}
              colors="transparentBg"
              style={{ display: 'inline-block' }}
            />
            <div className="reusecore-drawer__handler" onClick={toggleHandler} aria-label="Open menu">
              <HamburgMenu barColor="#fff" />
            </div>
            {state.isOpen && <div className="mobile_drawer_mask" onClick={toggleHandler} />}
            <div className={`mobile_drawer ${state.isOpen ? 'open' : ''}`} aria-hidden={!state.isOpen}>
              <button className="mobile_drawer_close" onClick={toggleHandler} aria-label="Close menu">×</button>
              <ScrollSpyMenu
                className="mobile_menu"
                menuItems={localizedData.MENU_ITEMS}
                drawerClose={true}
                offset={-100}
              />
              <a href="#contact" className="navbar_drawer_button">
                <Button
                  {...button}
                  title={enFr('GET IN TOUCH', 'NOUS CONTACTER')}
                  onClick={() => {
                    toggleHandler();
                    scrollToContact();
                  }}
                />
              </a>
              <a
                href={`${enFr(
                  'https://www.solutionsawaken.com',
                  'https://www.awakensolutions.com'
                )}${typeof window !== 'undefined' ? window.location.pathname + window.location.search + window.location.hash : '/'}`}
                className="drawer_lang"
              >
                {enFr('Français', 'English')}
              </a>
            </div>
          </Box>
        </Box>
      </Container>
    </NavbarWrapper>
  );
};

Navbar.propTypes = {
  navbarStyle: PropTypes.object,
  logoStyle: PropTypes.object,
  button: PropTypes.object,
  row: PropTypes.object,
  menuWrapper: PropTypes.object
};

Navbar.defaultProps = {
  navbarStyle: {
    minHeight: '70px',
    display: 'block'
  },
  row: {
    flexBox: true,
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  logoStyle: {
    // width: ['300px', '300px'],
    // maxWidth: ['170px', '200px']
  },
  button: {
    type: 'button',
    fontSize: '13px',
    fontWeight: '700',
    pl: '15px',
    pr: '15px',
    colors: 'primaryWithBg',
    minHeight: 'auto',
    height: '40px'
  },
  menuWrapper: {
    flexBox: true,
    alignItems: 'center'
  }
};

export default Navbar;
